import React from "react";
import { Switch } from "@mantine/core";
import { shallow } from "zustand/shallow";
import { useTranslation } from "react-i18next";

import useAppStore from "./contest-settings-store";

export default function WinnerRules({ canEditWinnerRules = true, onUpdate }) {
  const { t } = useTranslation();
  const { settings, setSettings } = useAppStore(
    (state) => ({
      settings: state.settings,
      setSettings: state.setSettings,
    }),
    shallow
  );

  return (
    <div>
      <Switch
        disabled={!canEditWinnerRules}
        mt="lg"
        label={t("mixer:contest_settings:winner_rules_title")}
        checked={settings.winner_rules.one_prize_per_winner}
        onChange={() =>
          onUpdate({
            one_prize_per_winner: !settings.winner_rules.one_prize_per_winner,
          })
        }
      />
    </div>
  );
}
